import { render, staticRenderFns } from "./editBasePrivilege.vue?vue&type=template&id=2df282f7"
import script from "./editBasePrivilege.vue?vue&type=script&lang=js"
export * from "./editBasePrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports